import templateUrl from "emun.vendor/vendorgroup-dashboard-header.htm";
import controller from "emun.vendor/vendorgroup-dashboard-header.controller";

export default {
  bindings: {
    vendor: "<"
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
